import { SxProps } from '@mui/material';

export const reviewsListContainer: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
};

export const reviewListItem: SxProps = {
	width: '100%',
	paddingY: '1rem',
	borderBottom: '1px solid',
	borderColor: 'divider',
	'&:last-child': {
		borderBottom: 'none',
	},
};
